import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { rootStore } from "@/store/RootStore";

const RestaurantBootstrapLayout = observer(() => {
  const { token, isAdmin } = rootStore.authStore;
  const store = rootStore.restaurantAccessStore;

  useEffect(() => {
    if (!token || isAdmin) return;

    if (!store.isBootstrapped) {
      store.bootstrapFromAssignments();
    }
  }, [token, isAdmin, store]);

  return <Outlet />;
});

export default RestaurantBootstrapLayout;
